import React from 'react';
import { StarIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getIcon } from '../../utils/iconUtils';
type PopularAppCardProps = {
  id: string;
  icon: string;
  iconBg: string;
  title: string;
  category: string;
  rating: number;
};
export const PopularAppCard = ({
  id,
  icon,
  iconBg,
  title,
  category,
  rating
}: PopularAppCardProps) => {
  return <Link to={`/app/${id}`} className="block bg-white rounded-xl p-4 border border-gray-200 hover:border-gray-300 transition-colors" data-id="element-50">
      <div className="flex items-center space-x-3 mb-3" data-id="element-51">
        <div className={`${iconBg} w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0`} data-id="element-52">
          {getIcon(icon)}
        </div>
      </div>
      <h3 className="font-semibold text-gray-900 mb-1 line-clamp-2" data-id="element-53">{title}</h3>
      <p className="text-sm text-gray-500 mb-2" data-id="element-54">{category}</p>
      <div className="flex items-center" data-id="element-55">
        <StarIcon className="h-4 w-4 text-amber-400 fill-amber-400" data-id="element-56" />
        <span className="ml-1 text-sm font-medium text-gray-700" data-id="element-57">{rating}</span>
      </div>
    </Link>;
};